import { createSlice } from "@reduxjs/toolkit";
import { getUserById, updateUserProfile } from "../actions/userActions";

const initialState = {
  user: {
    name: "",
    email: "",
    position: "",
    role: "",
    type: "",
    skills: [],
    gender: "",
    birthDate: "",
    address: "",
    telephone: "",
    about: "",
    social_medias: [],
    languages: [],
    edu_cert: [],
    isEmailVerified: false,
  },
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          ...state.user,
          ...action.payload,
          skills: action.payload.skills || [],
        };
      })
      .addCase(getUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = {
          ...state.user,
          ...action.payload,
          skills: action.payload.skills || state.user.skills,
        };
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
